var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[_c('Navbar',{attrs:{"topbarColor":_vm.topbarColor,"title":_vm.logotitle}}),_c('SideBar',{attrs:{"parent":".main-wrapper","sidebarLinks":_vm.sidebarLinks}}),_c('div',{staticClass:"main-container-fluid"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }